import { render, staticRenderFns } from "./ScreenSizeWatcher.vue?vue&type=template&id=a5d3555a&"
import script from "./ScreenSizeWatcher.vue?vue&type=script&lang=js&"
export * from "./ScreenSizeWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports